export enum SynchronizeEquipmentReturnType {
  CheckIfExists = 0,
  Attributs = 1,
  Documents = 2,
  Historic = 4,
  All = 7,
}
